<template>
  <div id="main">
    <header v-if="hasHeader">
      <v-header></v-header>
    </header>
    <main class="main">
      <router-view/>
    </main>
    <footer v-if="hasFooter">
      <v-footer></v-footer>
    </footer>
  </div>
</template>

<script>
import Header from '@/modules/header/index.vue'
import Footer from '@/modules/footer/index.vue'
import jQuery from 'jquery'
export default {
  name: 'Main',
  data(){
    return {
      hasHeader: true,
      hasFooter: true,
    }
  },
  components: {
    'v-header': Header,
    'v-footer': Footer
  },
  watch:{
    '$route':'getPath',
  },
  created(){
    if(location.pathname === '/get-the-app'){
      this.hasHeader = false;
      this.hasFooter = false;
    }
  },
  methods: {
    getPath(){
      if(location.pathname === '/get-the-app' && this.hasHeader && this.hasFooter){
        this.hasHeader = false;
        this.hasFooter = false;
      }else if(location.pathname !== '/get-the-app' && (!this.hasHeader) && (!this.hasFooter)){
        this.hasHeader = true;
        this.hasFooter = true;
      }
      jQuery('html,body').animate({"scrollTop": '0px'}, 500)
    }
  },
}
</script>
<style>
ul,ol,li{
  list-style: none;
}
p{
  margin: 0 0 10px;
}
#main main{
  margin-top: -10px;
  min-height: 50vh;
}

#main:has(header>.container-header) main{
  padding-top: 65px;
}

@media screen and (max-width: 800px){
  #main main{
    /* padding-top: 50px; */
    padding-top: 0px;
  }

  #main:has(header>.container-header) main{
    padding-top: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Main.vue